import axios from 'axios';
import {
    PRACTITIONER_LIST_REQUEST, PRACTITIONER_LIST_SUCCESS, PRACTITIONER_LIST_FAIL,
    PRACTITIONER_LIST_BY_IDS_REQUEST, PRACTITIONER_LIST_BY_IDS_SUCCESS, PRACTITIONER_LIST_BY_IDS_FAIL,
    PRACTITIONER_DETAILS_REQUEST, PRACTITIONER_DETAILS_SUCCESS, PRACTITIONER_DETAILS_FAIL,
    PRACTITIONER_CREATE_REQUEST, PRACTITIONER_CREATE_SUCCESS, PRACTITIONER_CREATE_FAIL,
    PRACTITIONER_UPDATE_REQUEST, PRACTITIONER_UPDATE_SUCCESS, PRACTITIONER_UPDATE_FAIL,
    PRACTITIONER_DELETE_REQUEST, PRACTITIONER_DELETE_SUCCESS, PRACTITIONER_DELETE_FAIL,
    PRACTITIONER_DTO_REQUEST, PRACTITIONER_DTO_SUCCESS, PRACTITIONER_DTO_FAIL,
} from '../constants/applicationUserConstants';

// Helper functions
const getAuthConfig = (token) => ({
    headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
});

const formatErrorMessage = (error) => {
    const errorMessages = [];
    if (error.response?.data) {
        if (error.response.data.errors) {
            Object.entries(error.response.data.errors).forEach(([key, value]) => {
                errorMessages.push(`${key}: ${value[0]}`);
            });
        }
        if (error.response.data.detail) {
            errorMessages.push(`Detail: ${error.response.data.detail}`);
        }
        if (error.response.data.message) {
            errorMessages.push(`Message: ${error.response.data.message}`);
        }
    }
    return errorMessages.length > 0 ? errorMessages : [error.message || "An error occurred, please try again later"];
};

const API_BASE_URL = '/dotnet_api/v1/applicationUser';

export const listApplicationUsers = (params = {}) => async (dispatch, getState) => {
    try {
        dispatch({ type: PRACTITIONER_LIST_REQUEST });
        const config = {
            ...getAuthConfig(getState().userLogin.userInfo.token),
            params
        };
        const { data } = await axios.get(`${API_BASE_URL}/all`, config);
        dispatch({ type: PRACTITIONER_LIST_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: PRACTITIONER_LIST_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const listApplicationUsersByIds = (ids) => async (dispatch, getState) => {
    try {
        dispatch({ type: PRACTITIONER_LIST_BY_IDS_REQUEST });
        const { data } = await axios.post(
            `${API_BASE_URL}/ids/all`,
            ids,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: PRACTITIONER_LIST_BY_IDS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: PRACTITIONER_LIST_BY_IDS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getApplicationUserDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: PRACTITIONER_DETAILS_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: PRACTITIONER_DETAILS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: PRACTITIONER_DETAILS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const createApplicationUser = (applicationUserData) => async (dispatch, getState) => {
    try {
        dispatch({ type: PRACTITIONER_CREATE_REQUEST });
        const { data } = await axios.post(
            API_BASE_URL,
            applicationUserData,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: PRACTITIONER_CREATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: PRACTITIONER_CREATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const updateApplicationUser = (id, changes) => async (dispatch, getState) => {
    try {
        dispatch({ type: PRACTITIONER_UPDATE_REQUEST });
        const { data } = await axios.patch(
            `${API_BASE_URL}/${id}`,
            changes,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: PRACTITIONER_UPDATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: PRACTITIONER_UPDATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const deleteApplicationUser = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: PRACTITIONER_DELETE_REQUEST });
        await axios.delete(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: PRACTITIONER_DELETE_SUCCESS });
    } catch (error) {
        dispatch({
            type: PRACTITIONER_DELETE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const loadApplicationUserDto = () => async (dispatch, getState) => {
    try {
        dispatch({ type: PRACTITIONER_DTO_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/dto`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: PRACTITIONER_DTO_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: PRACTITIONER_DTO_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getApplicationUserByIdentityUserId = (identityUserId) => async (dispatch, getState) => {
    try {
        dispatch({ type: PRACTITIONER_DETAILS_REQUEST });
        const { data } = await axios.get(
            `/dotnet_api/v1/applicationUser/by-identity-user/${identityUserId}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: PRACTITIONER_DETAILS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: PRACTITIONER_DETAILS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
}; 